import { Add } from "@mui/icons-material";
import { styled, Typography, useTheme } from "@mui/material";
import React, { useState } from "react";
import { Button, FlexRow, Spacer } from "../../components";
import { ACCOUNT_INITIAL_VALUES } from "../../data/accounts";
import { ColorsCodeType } from "../../typings";
import CreateAccountModal from "./CreateAccountModal";

const Wrapper = styled(FlexRow)`
  width: 100%;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0px 15px 0px;
`;

export const StyledPrimaryButton = styled(Button)`
  min-width: 0;
  min-height: 32px;
  padding: 0px 10px;
  border-radius: 5px;
  color: ${({ theme }) => theme.palette.colors.gray["900"]};
`;

const AccountsScreenHeader = () => {
  const theme = useTheme();
  const {
    palette: { colors },
  } = theme;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  return (
    <Wrapper>
      <Typography
        variant="h4"
        gutterBottom
        component="div"
        sx={{ fontWeight: "bold", color: "primary.main" }}
      >
        Accounts Dashboard
      </Typography>
      <StyledPrimaryButton
        buttonColor={colors["yellow"]["300"] as ColorsCodeType}
        onClick={handleOpenModal}
      >
        <Add fontSize="small" />
        <Spacer horizontal={0.3} />
        {"Create Account"}
      </StyledPrimaryButton>
      <CreateAccountModal
        open={isModalOpen}
        onClose={handleCloseModal}
        account={ACCOUNT_INITIAL_VALUES}
      />
    </Wrapper>
  );
};

export default AccountsScreenHeader;
